/** Mirrors API `role_id` from /me (see AuthContext). */
const ROLE_ADMIN = 1;
const ROLE_OWNER = 2;
const ROLE_FRONT_DESK = 4;

/**
 * Where to send a user after sign-in. Front Desk for staff, owners, and administrators (ops);
 * guest bookings for consumer accounts. Use /dashboard from the navbar for the legacy owner property UI when needed.
 * @param {object | null | undefined} user
 * @returns {string}
 */
export function getPostLoginPathFromUser(user) {
  if (!user) return '/my-bookings';
  const raw = user.role_id;
  const rid = raw != null && raw !== '' ? Number(raw) : NaN;
  const roleId = Number.isFinite(rid) ? rid : null;
  if (roleId === ROLE_FRONT_DESK || user.role === 'Front Desk') return '/front-desk';
  if (roleId === ROLE_OWNER || user.role === 'Owner') return '/front-desk';
  if (roleId === ROLE_ADMIN || user.role === 'Admin') {
    return '/front-desk';
  }
  return '/my-bookings';
}
